import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { CloakUtilService } from 'cloak-file-sdk-web'
import { KmsPlans, kmsUpgradeUrl, AppStr, UsageType } from 'cloak-file-sdk-web'
import withRouter from '../components/WithRouter';
import { createUsrUsage } from '../reducers/upgradeReducer'

// Plan picker + handoff to the KMS console.
//
// Rewritten 2026-07-29. The old page collected an account name and a seat count and
// posted them to PayPal per-seat checkout. Both inputs are now meaningless:
//
//   - Seats. Plans are a flat per-team subscription priced by Stripe price id, not
//     per user, so a seat count cannot change what the customer is charged. Asking
//     for one implied a per-seat bill that would never arrive.
//   - Account name. Cloak File accounts were created here as a side effect of
//     upgrading (AccountService.create). Entitlement now lives on the KMS
//     subscription row keyed by email, so upgrading no longer creates an account and
//     the field named something this page does not make.
//
// This page therefore only picks a plan and hands off. Payment is taken in the KMS
// console by Stripe; nothing here touches money. Deliberately NOT done: passing the
// Cloak File identity across as anything the KMS side would trust — see
// kmsUpgradeUrl() in the SDK for why that would be an entitlement-takeover path.
class UpgradePage extends PureComponent {

  goToKmsConsole(planCode) {
    // UPGRADE_TEXT previously meant "user typed in the account-name field". Reused
    // here as the intent signal for "user clicked through to checkout" so the
    // land → intent funnel keeps working; the enum is a fixed server-side
    // vocabulary, so adding an UPGRADE_PLAN_CLICK type needs a backend change first.
    this.props.dispatch(createUsrUsage(UsageType.UPGRADE_TEXT))
    window.open(kmsUpgradeUrl(planCode), '_blank', 'noopener,noreferrer')
  }

  componentDidMount() {
    console.log("In UpgradePage componentDidMount")
    CloakUtilService().checkInactivityLogout(this.props)

    this.props.dispatch(createUsrUsage(UsageType.UPGRADE_LAND))
  }

  renderPlan(plan) {
    return (
      <div className="clk-form-field-wrapper" key={plan.code}>
        <div className="clk-plan-card">
          <div className="clk-plan-name">{plan.label}</div>
          <div className="clk-plan-price">
            <strong>${plan.priceUsd}</strong>{' '}
            <small><FormattedMessage id="upgrade.perTeamPerMonth" /></small>
          </div>
          <p className="clk-plan-summary">
            <FormattedMessage id={plan.summaryId} />
          </p>
          <button className="clk-modal-button" onClick={() => this.goToKmsConsole(plan.code)}>
            <small>
              {plan.contactFirst
                ? <FormattedMessage id="upgrade.talkToUsFirst" />
                : <FormattedMessage id="upgrade.continueToKms" />}
            </small>
          </button>
        </div>
      </div>
    )
  }

  // No Processing / ErrorMessage overlay: this page performs no async work. Picking a
  // plan just opens the KMS console, and every failure mode after that point belongs
  // to the console and Stripe, which report it there.
  render() {
    return (
      <div>
        <div className="clk-primary-console-div clk-upgrade-console-div">
          <div className="clk-primary-console clk-upgrade-console clk-box-shadow ">
            <div>
              {/* The 40px inline top margin the other pages use is folded into the
                  container padding here, so the box does not open with dead space. */}
              <div>
                <div className="clk-main-title-div">
                  <div className="clk-main-title-text">
                    <FormattedMessage id="upgrade.upgrade" />
                  </div>
                </div>
              </div>

              <div className='clk-form-field-wrapper'>
                <FormattedMessage id="upgrade.kmsHandoff" />
              </div>

              {KmsPlans.map(plan => this.renderPlan(plan))}

              <div className='clk-form-field-wrapper'>
                <a href={AppStr.PRICING_URL} target="_blank" rel="noopener noreferrer">
                  <FormattedMessage id="upgrade.viewPlans" />
                </a>
              </div>

              <br /><br />
              <div className='clk-form-field-wrapper'>
                <FormattedMessage id="upgrade.enterpriseMsg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.auth.token
  }
};

export default connect(mapStateToProps)(withRouter(injectIntl(UpgradePage)));
